import React, { Component } from "react";
import _ from "lodash";
import { Parallax } from "react-skrollr";
import dayjs from 'dayjs';
import { withRedux } from "../../hoc";
import { ShowTimes, ContentItem, BackgroundImage, Feather, Image } from "../../components";
import { fetchApi } from "../../utils";

const image41 = `${process.env.PUBLIC_URL}/assets/images/section-3/bg-1.png`;
const image42 = `${process.env.PUBLIC_URL}/assets/images/section-3/image-1_05.png`;
const image51 = `${process.env.PUBLIC_URL}/assets/images/section-3/bg-2_12.png`;
const image52 = `${process.env.PUBLIC_URL}/assets/images/section-3/image-2_10.png`;
const image61 = `${process.env.PUBLIC_URL}/assets/images/section-3/bg-3.png`;
const image62 = `${process.env.PUBLIC_URL}/assets/images/section-3/image-3_18.png`;

const g15 = `${process.env.PUBLIC_URL}/assets/images/section-3/g15.png`;
const g21 = `${process.env.PUBLIC_URL}/assets/images/section-3/g21.png`;
const g31 = `${process.env.PUBLIC_URL}/assets/images/section-3/g31.png`;
const g33 = `${process.env.PUBLIC_URL}/assets/images/section-3/g33.png`;
const g41 = `${process.env.PUBLIC_URL}/assets/images/section-3/g41.png`;

const mapStateToProps = ({ language, t, posts }) => {
  const data = _.get(posts, "data");
  const highlights = _.filter(data, item => {
    const categoryID = _.get(item, "category.id");
    return categoryID === _.toNumber(process.env.REACT_APP_POST_HIGHLIGHT_ID);
  });
  return {
    language,
    t,
    highlights
  };
};

const actionToProps = {};

@withRedux(mapStateToProps, actionToProps)
export default class Section3 extends Component {
  state = {
    showtimes: null
  };
  componentDidMount() {
    // this.fetchRoundTime();
  }

  fetchRoundTime = async () => {
    await fetchApi(
      "booking/showtime",
      "POST",
      JSON.stringify({
        ShowDate: dayjs().format("YYYY/MM/DD")
      })
    )
      .then(res => _.get(res, "data"))
      .then(items => {
        this.setState(
          {
            showtimes: items
          }
          // () => this.getAboutShowtimes()
        );
      });
  };
  render() {
    const { highlights, t } = this.props;
    const { showtimes } = this.state;
    const ourshow1 = highlights[0];
    const ourshow2 = highlights[1];
    const ourshow3 = highlights[2];
    return (
      <div className="section-3">
        <div className="container">
          {showtimes && <ShowTimes showtimes={showtimes} />}

          <div className="container-highlight-show">
            <h2>
              TIFFANY’S SHOW PATTAYA
              <br />A SPECTACULAR WORLD CLASS SHOW
            </h2>
            {/* <Link to="/show">
              <Button ghost bordercolor="#ffb400">
                Our Show
              </Button>
            </Link> */}
          </div>
        </div>

        <Image className="g15" src={g15} alt="" />

        <div className="container-all-shows">
          <div className="container">
            <div className="container-block-item">
              <Parallax
                data={{
                  "data-bottom-top": "opacity: 0; transform: translateX(30px) translateZ(0px);",
                  "data-center-center": "opacity: 1; transform: translateX(0px) translateZ(0px);"
                }}
              >
                <ContentItem
                  title={t(_.get(ourshow1, "title"))}
                  content={t(_.get(ourshow1, "description"))}
                  nameButton="Preview"
                  link={`/highlight-detail/${_.get(ourshow1, "id")}`}
                />
              </Parallax>
            </div>
          </div>
          <div className="container-image-bg">
            <div className="parallax-container">
              <Parallax
                data={{
                  "data-bottom-top": "opacity: 0;",
                  "data-top-center": "opacity: 1;"
                }}
              >
                <BackgroundImage image={image41} />
              </Parallax>
            </div>
            <div className="person-top-1">
              <Parallax
                data={{
                  "data-bottom-top": "transform: translateY(200px) translateZ(0px);",
                  "data-top-bottom": "transform: translateY(0px) translateZ(0px);"
                }}
              >
                <Image src={image42} alt="" />
              </Parallax>
            </div>
          </div>
          <div className="container">
            <div className="container-block-item">
              <Parallax
                data={{
                  "data-bottom-top":
                    "opacity: 0; transform: translateX(30px) translateZ(0px); display: flex; justifyContent: flex-end;",
                  "data-center-center":
                    "opacity: 1; transform: translateX(0px) translateZ(0px); display: flex; justifyContent: flex-end;"
                }}
              >
                <ContentItem
                  title={t(_.get(ourshow2, "title"))}
                  content={t(_.get(ourshow2, "description"))}
                  nameButton="Preview"
                  link={`/highlight-detail/${_.get(ourshow2, "id")}`}
                />
              </Parallax>
            </div>
          </div>
          <div className="container-image-bg group2">
            <Image className="g21" src={g21} alt="" />
            <div className="parallax-container">
              <Parallax
                data={{
                  "data-bottom-top": "opacity: 0;",
                  "data-top-center": "opacity: 1;"
                }}
              >
                <BackgroundImage image={image51} />
              </Parallax>
            </div>
            <div className="person-top-2">
              <Parallax
                data={{
                  "data-bottom-top": "transform: translateY(200px) translateZ(0px);",
                  "data-top-bottom": "transform: translateY(0px) translateZ(0px);"
                  // "data": "display: flex; justifyContent: flex-end;",
                }}
              >
                <Image src={image52} alt="" />
              </Parallax>
            </div>
          </div>

          <div className="container">
            <div className="container-block-item">
              <Parallax
                data={{
                  "data-bottom-top": "opacity: 0; transform: translateX(30px) translateZ(0px);",
                  "data-center-center": "opacity: 1; transform: translateX(0px) translateZ(0px);"
                }}
              >
                <ContentItem
                  title={t(_.get(ourshow3, "title"))}
                  content={t(_.get(ourshow3, "description"))}
                  nameButton="Preview"
                  link={`/highlight-detail/${_.get(ourshow3, "id")}`}
                />
              </Parallax>
            </div>
          </div>
          <div className="container-image-bg group3">
            <Image className="g31" src={g31} alt="" />
            <Image className="g33" src={g33} alt="" />
            <Image className="g41" src={g41} alt="" />
            <div className="parallax-container">
              <Parallax
                data={{
                  "data-bottom-top": "opacity: 0;",
                  "data-top-center": "opacity: 1;"
                }}
              >
                <BackgroundImage image={image61} />
              </Parallax>
            </div>
            <div className="person-top-3">
              <Parallax
                data={{
                  "data-bottom-top": "transform: translateY(200px) translateZ(0px);",
                  "data-top-bottom": "transform: translateY(0px) translateZ(0px);"
                }}
              >
                <Image src={image62} alt="" />
              </Parallax>
            </div>
          </div>
        </div>
        <div className="feather-block">
          <div className="feather feather-1">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(-20px) translateY(-200px) translateZ(0px) scale(1) rotate(30deg);",
                "data-top-bottom": "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(10deg);"
              }}
            >
              <Feather type={1} />
            </Parallax>
          </div>
          <div className="feather feather-2">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(10px) translateY(-100px) translateZ(0px) scale(1) rotate(90deg);",
                "data-top-bottom": "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(0deg);"
              }}
            >
              <Feather type={2} />
            </Parallax>
          </div>
          <div className="feather feather-3">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(-5px) translateY(-150px) translateZ(0px) scale(1) rotate(-40deg);",
                "data-top-bottom": "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(0deg);"
              }}
            >
              <Feather type={3} />
            </Parallax>
          </div>
          <div className="feather feather-4">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(-50px) translateY(-150px) translateZ(0px) scale(1) rotate(-40deg);",
                "data-top-bottom": "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(20deg);"
              }}
            >
              <Feather type={9} />
            </Parallax>
          </div>
          <div className="feather feather-5">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(10px) translateY(-100px) translateZ(0px) scale(1) rotate(-10deg);",
                "data-top-bottom": "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(20deg);"
              }}
            >
              <Feather type={4} />
            </Parallax>
          </div>
          <div className="feather feather-6">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(-10px) translateY(-50px) translateZ(0px) scale(1) rotate(0deg);",
                "data-top-bottom": "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(-45deg);"
              }}
            >
              <Feather type={2} />
            </Parallax>
          </div>
          <div className="feather feather-7">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(10px) translateY(-50px) translateZ(0px) scale(1) rotate(-25deg);",
                "data-top-bottom": "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(25deg);"
              }}
            >
              <Feather type={9} />
            </Parallax>
          </div>
          <div className="feather feather-8">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(0px) translateY(-50px) translateZ(0px) scale(1) rotate(0deg);",
                "data-top-bottom": "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(45deg);"
              }}
            >
              <Feather type={7} />
            </Parallax>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Section3.js